export default "__VITE_ASSET__BHOxF9tg__"